module.exports = __webpack_public_path__ + "/img/Header-Female-Straight-xaZkhX.svg";